// Utils
import FilterData from '@/utils/filter-data'
import URLParams from '@/utils/url-params'
import IsNumber from '@/utils/is-number'

const SearchLink = (pathname: string, searchParams: Record<string, string>) => {
	// Create Params
	const reqParams: Record<string, string> = {}

	Object.keys(searchParams).map(index => {
		const param = searchParams[index]

		if (index !== 'page') reqParams[index] = param
		else if (IsNumber(param) && parseInt(param) > 1) reqParams.page = param
	})

	// Create Link
	let output: string = `${pathname}${Object.keys(reqParams).length ? `?${URLParams(FilterData(reqParams))}` : ''}`

	return output
}

export default SearchLink
